import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.warn(
    'Supabase 환경변수가 설정되지 않았습니다. .env.local의 REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_PUBLISHABLE_KEY 를 확인하세요.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);
